import { render } from "./CenterGlobalSearch.vue?vue&type=template&id=283fed15"
import script from "./CenterGlobalSearch.vue?vue&type=script&lang=js"
export * from "./CenterGlobalSearch.vue?vue&type=script&lang=js"

import "./CenterGlobalSearch.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__